import { render, staticRenderFns } from "./ruleTemplateBox.vue?vue&type=template&id=3366885b"
import script from "./ruleTemplateBox.vue?vue&type=script&lang=js"
export * from "./ruleTemplateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports